import Vue from 'vue'
// vue-awesome icons
import '@/utils/icons.js'
// imports
import Icon from 'vue-awesome/components/Icon'
import App from '@/App.vue'
import router from '@/router'
import { store } from '@/store/store'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.component('v-icon', Icon)
Vue.config.productionTip = true
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCWElzu5SDbvr4IzNAoJrkvkGcPfzfKtZ8',
    libraries: 'places'
  }
})

// router hooks
router.beforeEach((to, from, next) => {
  window.scroll({
    top: 0,
    left: 0
  })
  next()
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
